window.onerror = msg => {
    console.error(msg);
    elem.msgText.innerHTML = msg;
    msa.showInFooter('msg');
};

msa.thumbSize = msa.getPhotoSize('thumb');
msa.x2ThumbSize = msa.getPhotoSize('x2');
msa.viewSize = msa.getPhotoSize('selected');
msa.photoWidths = msa.calcPhotoWidths();

msa.resize = msa.debounce(() => {
    const photos = [...document.querySelectorAll('.photo')];
    msa.photoWidths = msa.calcPhotoWidths();
    msa.resizePhotoWidths(photos);
    msa.invalidateLoaded(photos);
    setTimeout(() => {
        msa.iso.layout();
    }, 0);
}, 200);

msa.setSectionFromUrl();
msa.setFilterFromHash();
msa.setMenuFromFilter();
msa.applyFilter('map');

if (window.location.pathname.substring(1) === 'map') {
    elem.icons.toggle.classList.remove('map-icon');
}

msa.map = L.map('map').setView([-37.81, 144.99], 15);

/**
 * Initialize Stamen.Terrain TileLayer on street map.
 * http://leaflet-extras.github.io/leaflet-providers/preview/index.html
 */
L.tileLayer('https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.{ext}', {
    attribution:   'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    subdomains:    'abcd',
    minZoom:       0,
    maxZoom:       18,
    ext:           'png'
}).addTo(msa.map);

// Add markers to street map
for (let photo of Object.keys(photos)) {
    const x = photos[photo].GPSLatitude,
          y = photos[photo].GPSLongitude;
    if (typeof x === 'number' && x < -30 && typeof y === 'number' && y > 135) {
        const icon = L.icon({
            iconUrl:       '/images/icons/marker.png',
            iconRetinaUrl: '/images/icons/marker-2x.png',
            shadowUrl:     '/images/icons/marker-shadow.png',
            iconSize:      [25, 41],
            shadowSize:    [41, 41],
            iconAnchor:    [12.5, 41],
            popupAnchor:   [0, -46],
            className:     photos[photo].Tags.join(' ')
        });
        msa.markers[photo] = L.marker([x, y], { icon, riseOnHover: true }).addTo(msa.map);
    }
}

// Photos must be added before initializing Isotope
msa.insertPhotos(photos, true);

msa.iso = new Isotope(elem.sections.photos, {
    itemSelector: '.photo',
    layoutMode: 'packery',
    resize: false,
    //transitionDuration: '0.4s',

    // String selector or function that returns boolean
    filter: itemElem => [...itemElem.classList]
        .filter(tag => msa.filter.has(tag)).length,

    // Options specific to the packery layout mode
    packery: { horizontal: true, gutter: 5 },

    // Styles applied to hide items when filtering
    hiddenStyle: { opacity: 0, transform: 'scale(0.001)' },

    // Styles applied to reveal items when filtering
    visibleStyle: { opacity: 1, transform: 'scale(1)' }

    // Isotope reads data from HTML with the getSortData option
    //getSortData: { name: '.name', category: '[data-category]' }
});

msa.iso.layout();
window.scroll(0, 0);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
        /* .then(reg => {
            console.info('Service worker registered with scope:', reg.scope);
        }) */
        .catch(error => {
            console.error('Service worker not registered:', error);
        });
}
